<template>
  <div class="container">
    <homeHeader title="数据处理" :isShowProjectSelect="true" @changeSelect="changeSelect"></homeHeader>
    <div class="main">
      <div class="card">
        <!-- 按钮组 -->
        <div class="toolbar-dv">
          <toolBarBtn
            @changeSearchFormShow="changeSearchFormShow"
            :buttonVisible="buttonVisible"
            :moreButtonList="moreButtonList"
            :parentData="this"
            ref="toolBarBtn"
          ></toolBarBtn>
        </div>
        <!-- 查找面板 -->
        <!-- <div class="search-dv" v-show="searchFormVisible">
          <SearchForm
            ref="SearchForm"
            v-show="searchFormVisible"
            :searchVuePath="searchVuePath"
            :menuArgs="''"
            @search="sureSearch"
          ></SearchForm>
        </div> -->
        <!-- 主表信息 -->
        <div class="approve-table-dv">
          <!-- 菜单明细 -->
          <div class="menu-dv" :style="{ height: this.approveCardHeight }">
            <div class="table-dv">
              <vxe-grid
                ref="xTable"
                resizable
                :column-config="{ minWidth: '80px' }"
                :data="tableData"
                :showOverflow="true"
                size="mini"
                :mouse-config="{ area: true }"
                :tooltip-config="{
                  showAll: true,
                  theme: 'dark'
                }"
                :pager-config="tablePage"
                @page-change="handlePageChange"
                :seq-config="{
                  startIndex: (tablePage.currentPage - 1) * tablePage.pageSize
                }"
                highlight-hover-row
                highlight-current-row
                :height="tableHeight"
                :columns="gridColumnsMenu"
                @cell-dblclick="handleDblclick"
                :keyboard-config="{
                  isArrow: true,
                  isEnter: true,
                  isTab: true,
                  isClip: true,
                  enterToTab: true,
                  isEdit: true
                }"
                @cell-menu="cellContextMenuEvent"
                :menu-config="{
                  body: { options: bodyMenus },
                  visibleMethod: visibleMethod
                }"
                @menu-click="contextMenuClickEvent"
                :cell-style="tableCellStyle"
              >
              </vxe-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 新增修改模态窗 -->
    <AddOrSeeDataProcessingModal ref="AddOrSeeDataProcessingModal" />
    <!-- 处理模态窗 -->
    <AcceptModal ref="AcceptModal" modalSource="DataProcessing" @sureHandler="sureHandlerAccept" />
    <!-- 评价模态窗 -->
    <AssessModal ref="AssessModal" @sureHandler="sureHandlerAssess" />
    <!-- 评价待处理模态窗 -->
    <AssessTodoModal ref="AssessTodoModal" :tableData.sync="tableDataTodo" />
  </div>
</template>

<script>
import AddOrSeeDataProcessingModal from './AddOrSeeDataProcessingModal.vue'
import AcceptModal from '../RequirementsGather/AcceptModal.vue'
import AssessModal from '../RequirementsGather/AssessModal.vue'
import AssessTodoModal from './AssessTodoModal.vue'
export default {
  name: 'DataProcessing',
  components: { AddOrSeeDataProcessingModal, AcceptModal, AssessModal, AssessTodoModal },
  data() {
    return {
      id: 0,
      // 是否显示查询
      searchFormVisible: false,
      // 查询条件
      searchObjects: [],
      gridColumnsMenu: [],
      // 查询条件vuepath
      searchVuePath: 'DataProcessing',
      // 正常状态下，需要加上表格距离card上下的margin
      topBottomMargin: 20,
      // 按钮组的可见性
      buttonVisible: {
        add: true, // 新增按钮是否显示
        update: false, // 修改按钮
        save: false, // 保存按钮是否显示
        delete: false, // 删除按钮是否显示
        refresh: true, // 刷新数据按钮是否显示
        lock: false, // 锁定按钮是否显示
        unlock: false, // 解锁按钮是否显示
        sort: false, // 排序按钮是否显示
        search: false, // 查找按钮是否显示
        more: false // 更多按钮是否显示
      },
      // form: {
      // },
      // detailListBRoleEmployee: [],
      tableData: [],
      // 获取权限
      Authority: this.AuthorityFilter(this.$route.path),
      // 模态窗类型
      modalType: '',
      // 模态窗id,用于修改单据
      modalId: 0,
      // 分页设置
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: this.tablePageConfig.pageSize,
        align: 'right',
        pageSizes: this.tablePageConfig.pageSizes,
        layouts: ['Sizes', 'PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'FullJump', 'Total'],
        perfect: true
      },
      // 产品类型
      optionsValue: '',
      // 右键缓存
      areas: {},
      colProperty: '',
      // 右键缓存id
      cellIdList: [],
      // 设置版本类型(实际、预计)
      setVersionType: '',
      // 拓展按钮
      moreButtonList: [],
      // 待评价数据
      tableDataTodo: [],
      // 设置更新批次默认值
      defaultBatchNum: '',
      // 右键
      bodyMenus: [
        [
          {
            code: 'handle',
            name: '处理'
          },
          {
            code: 'assess',
            name: '评价'
          }
        ]
      ],
      // 当前账户的用户类型
      myUserClass: this.$store.state.userInfo.gangWei,
      myUserName: this.$store.state.userInfo.userName,
      myUserCompany: this.$store.state.userInfo.company,
      // 处理明细行
      handleList: []
    }
  },
  mounted() {},
  created() {
    this.InitColumn()
    this.moreButtonList = [
      {
        name: '清空筛选',
        icon: 'el-icon-brush',
        visible: true,
        event: 'handleClearFilter'
      }
      // {
      //   name: "同步至协作项目",
      //   icon: "iconfont fjyk-sync",
      //   visible:
      //     this.$store.state.userInfo.gangWei === "运维" ||
      //     this.$store.state.userInfo.gangWei === "管理",
      //   event: "handleCloudSync",
      // },
    ]
  },
  methods: {
    // 动态样式 - 主要用于区分版本是否更新
    tableCellStyle({ row }) {
      // 有实际更新版本时，显示绿色
      if (this.ykDateFormat('yyyy-MM-dd', row['issuedTime'])) {
        return {
          backgroundColor: '#2ed573'
        }
        // 如果结果为不处理时，显示红色
      } else if (row['handleResult'] === '不处理') {
        return {
          backgroundColor: '#f56c6c',
          color: '#fff'
        }
        // 无实际版本有预计更新版本时，显示黄色
      } else if (
        this.ykDateFormat('yyyy-MM-dd', row['handleTime']) &&
        !this.ykDateFormat('yyyy-MM-dd', row['issuedTime'])
      ) {
        return {
          backgroundColor: '#fffa65'
        }
      }
    },
    // 新增前
    async beforeAddOrUpdate(type = 'add', isRefresh = false) {
      if (!this.$store.state.productType) {
        this.$message.error('您暂未拥有产品类型或未选中产品类型,如有疑问请联系管理员!')
        return
      }
      const { data: res } = await this.$http.get('/Bugs/YKDataProcessing/unassess', {
        params: {
          productionType: this.$store.state.productType,
          id: type === 'update' ? this.id : 0
        }
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.tableDataTodo = res.data
      // 刷新数据
      if (isRefresh) {
        await this.refresh()
      }
      if (res.data.length > 0) {
        // 如果含有未评价明细打开窗口进行评价
        this.$refs.AssessTodoModal.formVisible = true
        return false
      } else {
        // 全部评价完后关闭窗口
        this.$refs.AssessTodoModal.formVisible = false
        return true
      }
    },
    // 同步至协作系统接口
    async syncCooperationDPBugHttp(form) {
      const handleList = this.handleList.map(item => {
        const ITEM = {
          ykDataProcessingID: item.id,
          productionType: item.productionType,
          groupName: item.groupName,
          vuePath: item.vuePath,
          title: item.userCompany + ' [' + item.vuePath + '] ' + '数据处理',
          requirementDesc:
            '<h3>客户需求:</h3>    ' +
            item.requirementDesc +
            (form.handleNote ? '<br /><br /><h3>处理意见:</h3>    ' + form.handleNote : ''),
          deadLineTime: form.deadLineTime,
          openedBy: this.myUserName,
          assignedTo: '刘坤辉'
        }
        return ITEM
      })
      const { data: res } = await this.$http.post('/Common/DPBugs/synchronize', handleList, {
        headers: {
          cooperation: true
        }
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 调用协作系统处理之后执行的接口
    async handleCooperationHttp(form) {
      const that = this
      // 获取出id
      const idList = this.handleList.map(item => {
        return item.id
      })
      const { data: res } = await that.$http.put('/Bugs/YKDataProcessing/handle', {
        ...form,
        idList: idList
      })
      if (!res.isSuccess) {
        that.$message.error(res.errorMessage)
        return false
      }
      that.$message.success('处理成功!')
      that.refresh()
    },
    // 回调 => 处理
    async sureHandlerAccept(form) {
      // const that = this
      // that
      //   .$confirm('处理之后不能撤回, 是否确认处理?', '提示', {
      //     confirmButtonText: '是',
      //     cancelButtonText: '否',
      //     type: 'warning'
      //   })
      //   .then(async () => {
      let flag = false
      if (form.handleResult === '不处理') {
        flag = true
      } else {
        // 先调用协作系统接口，结果为true时再进行处理成功操作
        flag = await this.syncCooperationDPBugHttp(form)
      }
      if (flag) {
        await this.handleCooperationHttp(form)
      }
      // })
    },
    // 回调 => 评价
    sureHandlerAssess(form) {
      const that = this
      // 获取出id
      const idList = this.handleList.map(item => {
        return item.id
      })
      this.$confirm('评价之后不能撤回, 是否继续评价?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(async () => {
        let action = form.assessResult === '满足' ? '关闭' : '激活'
        let comment =
          form.assessResult === '满足' ? '满足' : that.myUserCompany + ' ' + that.myUserName + ': ' + form.assessNote
        let actor = this.$store.state.productType === '铁塔' ? '沈木全' : '刘坤辉'
        let flag = await that.syncQuestionState({
          ykDataProcessingIDList: idList,
          action,
          actor,
          comment
        })
        if (flag) {
          const { data: res } = await that.$http.put('/Bugs/YKDataProcessing/assess', {
            ...form,
            idList: idList
          })
          if (!res.isSuccess) {
            that.$message.error(res.errorMessage)
            return false
          }
          that.$message.success('评价成功!')
          that.refresh()
        } else {
          this.$message.error('评价失败，请联系管理员')
        }
      })
    },
    // 评价后同步协作系统
    async syncQuestionState({ ykDataProcessingIDList, action, actor, comment }) {
      const { data: res } = await this.$http.post(
        '/Common/DPBugs/judge',
        {
          ykDataProcessingIDList,
          action,
          actor,
          comment
        },
        {
          headers: {
            cooperation: true
          }
        }
      )
      if (!res.isSuccess) {
        return false
      }
      return true
    },
    // 按下右键缓存选中列
    cellContextMenuEvent({ column }) {
      this.areas = this.$refs.xTable.getCellAreas()
      this.colProperty = column.property
    },
    // 右键控制菜单方法
    visibleMethod({ options, column }) {
      // 显示之前处理按钮的操作权限
      options.forEach(list => {
        list.forEach(item => {
          if (column) {
            // item.disabled = !this.$parent.Authority.edit
            if (item.code === 'handle') {
              item.visible = ['管理', '运维'].includes(this.myUserClass)
            } else if (item.code === 'assess') {
              item.visible = this.myUserClass === '客户'
            }
          } else {
            item.visible = false
          }
        })
      })
      return true
    },
    // 右键确认
    contextMenuClickEvent({ menu }) {
      this.handleList = []
      this.areas.forEach(area => {
        for (let row of area.rows) {
          for (let col of area.cols) {
            if (col.property === this.colProperty) {
              // 没有人处理的情况下, 才可操作
              if (menu.code === 'handle') {
                this.handleList.push(row)
                // 存在完成处理日期才可评价
              } else if (menu.code === 'assess' && this.ykDateFormat('yyyy-MM-dd', row.issuedTime)) {
                //  &&
                // row.assessorID === 0
                this.handleList.push(row)
              }
            }
          }
        }
      })
      switch (menu.code) {
        case 'handle':
          if (this.handleList.length > 0) {
            this.$refs.AcceptModal.formVisible = true
          } else {
            this.$message.error('选中行没有需要您操作的数据哦~')
          }
          break
        case 'assess':
          if (this.handleList.length > 0) {
            this.$refs.AssessModal.formVisible = true
          } else {
            this.$message.error('选中行没有需要您操作的数据哦~')
          }
          break
      }
    },
    // 清空筛选
    handleClearFilter() {
      this.$refs.xTable.clearFilter()
    },
    // 同步至协作项目
    // handleCloudSync() {
    //   this.$refs.SyncToCooperation.formVisible = true
    // },
    // 页面函数
    handlePageChange({ currentPage, pageSize }) {
      const that = this
      that.tablePage.currentPage = currentPage
      that.tablePage.pageSize = pageSize
      that.list()
    },
    // 切换产品类型
    changeSelect(type) {
      // 注意！每次切换必须缓存产品类型值，才能在保存和activated触发时取到当前选择的类型
      this.optionsValue = type
      localStorage.setItem('productType', type)
      this.$store.commit('set_productType', this.optionsValue)
      // 重新加载列，可以清除列头筛选
      this.list()
      this.InitColumn()
    },
    // 初始化
    InitColumn() {
      this.gridColumnsMenu = [
        { type: 'seq', width: 40, fixed: 'left' },
        // { title: '序号', field: 'num' },
        // {
        //   title: '产品类型',
        //   field: 'productionType',
        // },
        {
          title: '模块',
          field: 'groupName',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' },
          fixed: 'left'
        },
        {
          minWidth: '120px',
          title: '菜单',
          field: 'vuePath',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' },
          fixed: 'left'
        },
        {
          minWidth: '120px',
          title: '登记单位',
          field: 'userCompany',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' },
          fixed: 'left'
        },
        {
          minWidth: '120px',
          title: '登记人员',
          field: 'recorder',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' },
          fixed: 'left'
        },
        {
          minWidth: '90px',
          title: '登记日期',
          field: 'recordDate',
          formatter: 'formatDate',
          cellType: 'string',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend', valueFormat: 'date' }
        },
        {
          title: '数据处理描述',
          width: '150px',
          field: 'requirementDesc',
          filters: [{ data: null }],
          filterRender: { name: 'FilterInput' }
        },
        {
          title: '处理结果',
          field: 'handleResult',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '处理说明',
          field: 'handleNote'
        },
        {
          title: '运维人员',
          field: 'handler',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          minWidth: '90px',
          title: '处理日期',
          field: 'handleTime',
          formatter: 'formatDate',
          cellType: 'string'
          // filters: [
          //   {
          //     data: {
          //       vals: [],
          //       sVal: '',
          //       fMenu: '',
          //       f1Type: '',
          //       f1Val: '',
          //       fMode: 'and',
          //       f2Type: '',
          //       f2Val: ''
          //     }
          //   }
          // ],
          // filterRender: { name: 'FilterExtend', valueFormat: 'date' }
        },
        {
          minWidth: '100px',
          title: '完成处理日期',
          field: 'issuedTime',
          formatter: 'formatDate',
          cellType: 'string',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend', valueFormat: 'date' }
        },
        {
          title: '评价',
          field: 'assessResult',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        { title: '评价说明', field: 'assessNote' },
        { title: '评价人', field: 'assessor' },
        {
          title: '评价时间',
          field: 'assessTime',
          width: '120px',
          formatter: 'formatDate'
        }
      ]
    },
    // 切换查询面板可见性
    changeSearchFormShow() {
      this.searchFormVisible = !this.searchFormVisible
    },
    // 双击数据
    handleDblclick({ row }) {
      this.id = row.id
      // this.form = row
      this.update()
    },
    // 新增
    async add() {
      const flag = await this.beforeAddOrUpdate('add')
      if (flag) {
        this.$refs.AddOrSeeDataProcessingModal.id = -1
        this.$refs.AddOrSeeDataProcessingModal.modalType = '新增'
        this.$refs.AddOrSeeDataProcessingModal.isShow = true
      }
    },
    // 修改按钮
    async update() {
      const flag = await this.beforeAddOrUpdate('add')
      if (flag) {
        this.$refs.AddOrSeeDataProcessingModal.id = this.id
        this.$refs.AddOrSeeDataProcessingModal.modalType = '修改'
        this.$refs.AddOrSeeDataProcessingModal.isShow = true
      }
    },
    // 刷新数据
    refresh() {
      if (!this.Authority.see) {
        this.$message.error('您没有相关权限！')
        return
      }
      this.list()
    },
    // 获取数据
    async list() {
      const { data: res } = await this.$http.post('/Bugs/YKDataProcessing/list', {
        pageIndex: this.tablePage.currentPage,
        pageSize: this.tablePage.pageSize,
        seeType: this.Authority.seeType,
        sqlTitle: this.optionsValue,
        searchObjects: this.searchObjects
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.tableData = res.data.rows
      this.tablePage.total = res.data.totals
    },
    // 修改模态窗类型
    updateModalType(Str) {
      this.modalType = Str
    },
    // 点击导出
    async exp() {
      const that = this
      that.$refs.xTable.exportData({
        filename: '数据处理',
        sheetName: 'Sheet1',
        type: 'xlsx',
        columnFilterMethod({ column }) {
          return column.property !== undefined
        }
      })
    }
  },
  computed: {
    tableHeight() {
      let isSearchForm = this.searchFormVisible
      let isToolBar = true

      // 若有查询框，则共有四段 margin; 否则只有表格的两段 margin
      let tableMargin = isSearchForm ? this.heightConfig.mainMargin * 4 : this.heightConfig.mainMargin * 2
      return this.tableHeightComputed(tableMargin + this.topBottomMargin, isSearchForm, isToolBar)
    },
    // 表格容器高度，需加上margin边距
    approveCardHeight() {
      return this.tableHeight + this.topBottomMargin
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - @header-height);
  overflow: hidden;
}
.card {
  margin: @main-margin;
  box-shadow: #bebebe 2px 2px 10px;
  border-radius: 10px;
  overflow: hidden;
}
.search-dv {
  background-color: aquamarine;
  height: 100px;
  margin: @main-margin 10px;
}

.toolbar-dv {
  padding: 10px;
}

.table-dv {
  padding: @topBottomMargin;
}

// .approve-table-dv {
//   display: flex;
//   // 行高度，需要比 row-config 的 height 多20px，可以让内容与单元格之间有内边距
//   /deep/ .vxe-body--row {
//     height: 80px !important;
//   }
// }
// 角色名称列表
.left-role-dv {
  width: 15%;
  padding: 10px;
}
.role-list-dv {
  width: 100%;
  border-radius: 5px;
  box-shadow: #e2e2e2 0px 0px 3px;
  border: 1px solid #eeeeee;
  overflow: hidden;
  position: relative;
}

// 用户名列表
.middle-user-dv {
  width: 35%;
}
// 权限菜单列表
.menu-dv {
  width: 100%;
}

.vxe-checkbox {
  width: 15px !important;
}
</style>
